'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const SelectionSetTileDescription = renderWithRef('SelectionSetTileDescription', null, (t, r)=>jsx(RenderComp, {
        root: "p",
        forwardedRef: r,
        classNames: [
            'swan-selection-set-tile-description'
        ],
        props: t,
        children: t.children
    }));

export { SelectionSetTileDescription };
